import styled from "styled-components";

export const AccountPage = styled.div`
  .main-sec {
    display: grid;
    grid-template-columns: 46px auto;
    grid-column-gap: 24px;

    .image-avatar {
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }
    .user-icon {
      width: 46px;
      height: 46px;
      img {
        height: 46px;
        width: 46px;
      }
    }
    .name-avatar {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background: black;
      color: white;
      text-align: center;

      div {
        line-height: 46px;
        font-size: 24px !important;
        font-weight: bold;
        font-family: "Futura LT Light" !important;
      }
    }
    .guide-text {
      grid-column: 2/3;
    }    
  }
`;
export const AccountBoard = styled.div`
  display: flex;

  .left-part {
    width: 65%;
    padding-right: 16px;
  }

  .right-part {
    width: 35%;
  }

  @media screen and (max-width: 860px) {
    display: block;

    & > div {
      width: 100% !important;
      padding: 0px !important;
      overflow: hidden;
    }
  }

  .gift-slides-wrapper {
    margin-left: calc(-10% + 48px);
    margin-right: calc(-10% + 48px);

    .slick-arrow.slick-next {
      right: calc(10% - 48px) !important;
    }
    .slick-arrow.slick-prev {
      left: calc(10% - 48px) !important;
    }

    @media screen and (max-width: 575px) {
      margin-left: calc(-12.5% + 50px);
      margin-right: calc(-12.5% + 50px);

      .slick-arrow.slick-next {
        right: calc(12.5% - 50px) !important;
      }
      .slick-arrow.slick-prev {
        left: calc(12.5% - 50px) !important;
      }
    }

    @media screen and (max-width: 480px) {
      margin-left: calc(-16.666% + 53.333px);
      margin-right: calc(-16.666% + 53.333px);

      .slick-arrow.slick-next {
        right: calc(16.666% - 53.333px) !important;
      }
      .slick-arrow.slick-prev {
        left: calc(16.666% - 53.333px) !important;
      }
    }

    @media screen and (max-width: 400px) {
      margin-left: calc(-25% + 60px);
      margin-right: calc(-25% + 60px);

      .slick-arrow.slick-next {
        right: calc(25% - 60px) !important;
      }
      .slick-arrow.slick-prev {
        left: calc(25% - 60px) !important;
      }
    }
  }

  .slides-wrapper {
    width: calc(100% - 80px);

    .slides-inner {
      width: 100%;
      margin-left: calc(10% - 41px);
      .slick-arrow.slick-next {
        right: calc(10% - 41px) !important;
      }

      @media screen and (max-width: 575px) {
        margin-left: calc(12.375% - 40px);
        .slick-arrow.slick-next {
          right: calc(12.375% - 40px) !important;
        }
      }

      @media screen and (max-width: 480px) {
        margin-left: calc(16.666% - 40px);
        .slick-arrow.slick-next {
          right: calc(16.666% - 40px) !important;
        }
      }

      @media screen and (max-width: 400px) {
        margin-left: calc(25% - 40px);
        .slick-arrow.slick-next {
          right: calc(25% - 40px) !important;
        }
      }
    }
  }

  .slick-track {
    margin-left: 0px !important;
  }

  .slick-arrow {
    top: 40px !important;
    background: #ffffffd1;
    border-radius: 20px;
    width: 24px;
    height: 24px;
    padding: 4px;
    z-index: 2;
    &::before {
      display: none;
    }
    img {
      width: 16px;
      height: 16px;
    }

    &.slick-prev {
      left: -6px;
    }
  }

  .info-section {
    display: grid;
    grid-template-columns: 170px auto;
    grid-column-gap: 16px;
    margin-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    min-height: 40px;
  }
`;

export const BottomBar = styled.div`
  position: fixed;
  bottom: 20px;
  max-width: 980px;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 1000;
  -webkit-box-align: center;
  align-items: center;
  pointer-events: none;
  -webkit-box-pack: end;
  justify-content: flex-end;

  @media screen and (max-width: 1110px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  a {
    padding: 16px 8px;
    width: 150px;
    text-align: center;
    border: 1px solid rgb(255, 255, 255);
    border-radius: 100px;
    line-height: 1.5;
    z-index: 1000;
    cursor: pointer;
    pointer-events: auto;
    color: white !important;
  }
`;

//////////////////////////////////////////////////////////////////////////////////////////
////////////////////////// My Profile page - ////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
export const SliderItem = styled.div`
  text-align: center;
  position: relative;

  .placeholder-image {
    position: relative;
    width: 80px;
    height: 80px;
    margin: auto;

    &::after {
      position: absolute;
      content: "";
      width: 80px;
      height: 80px;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #c7c7c788;
    }
  }

  .favorite-mark {
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    left: unset;
    position: absolute;
  }
`;
export const ItemImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  margin: auto;
  overflow: hidden;

  &.more-item {
    text-align: center;
    background: black;
    color: white;
    font-size: 18px;
    display: flex;
    align-items: center;
    font-family: "Futura LT Light";
    font-weight: 600;
    cursor: pointer;
  }
`;
export const NameAvatar = styled.div`
  width: 80px;
  height: 80px;
  margin: auto;
  border-radius: 40px;
  background-color: black;
  color: white;
  font-size: 48px;
  line-height: 80px;
  font-family: "Futura LT light";
`;
export const PlusButton = styled.div`
  width: 80px;
  height: 80px;
  min-width: 80px;
  border-radius: 50%;
  background-color: black;
  display: flex;

  span {
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
    font-family: Assistant, sans-serif;
    font-weight: 200;
    font-size: 40px;
    cursor: pointer;
    color: white;
  }
`;

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
export const ProfileBoard = styled.div`
  display: grid;
  grid-template-columns: 200px auto;
  grid-column-gap: 16px;

  & > div:nth-child(n + 3) {
    grid-column: 1/3;
  }

  @media screen and (max-width: 680px) {
    display: block;
  }

  .avatar-section {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    .image-avatar {
      width: 130px;
      height: 130px;
      object-fit: cover;
      border-radius: 50%;
    }
    .name-avatar {
      width: 130px;
      height: 130px;
      border-radius: 50%;
      background-color: black;
      color: white;
    }
  }

  .info-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;

    @media screen and (max-width: 680px) {
      display: block;
      padding-right: 8px;
    }
  }

  .favorite-input-form {
    display: grid;
    grid-template-columns: 200px auto;
    grid-column-gap: 8px;
    margin-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;

    @media screen and (max-width: 575px) {
      display: block;

      textarea {
        display: block;
        width: 100%;
      }
    }

    textarea {
      min-height: 80px;
    }
  }

  .interest-options {
    padding-left: 8px;
    padding-right: 8px;
    display: grid;
    grid-template-columns: 1fr 1fr;

    
    @media screen and (max-width: 450px) {
      display: block;
    }
  }

  @media screen and (max-width: 680px) {
    & > div {
      grid-column: 1/3;
    }
  }
`;

///////////////////////////////////////////////////////////////////////////
/////////////////////// User Detail Page ////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////

export const UserDetail = styled.div`
  .main-info-section {
    display: grid;
    grid-template-columns: 170px auto 140px;
    grid-gap: 12px;

    .event-date {
      width: 74px;
    }

    @media screen and (max-width: 680px) {
      grid-template-columns: 160px auto;

      .name-events {
        grid-column: 1/3;
        grid-row: 2/3;
        padding-top: 12px;
      }
      
      .profile_section button {
        max-width: 250px !important;
      }

      .actions button {
        max-width: 140px;
        margin-left: auto;
      }

      
    }

    @media screen and (max-width: 380px) {
      grid-template-columns: 130px auto;
    }
  }

  .avatar,
  .image-wrapper {
    width: 100%;
    height: 0px;
    padding-top: 100%;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    display: block;

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .name-avatar {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: black;
      color: white;
    }
  }

  .favorite-input-form {
    display: grid;
    grid-template-columns: 200px auto;
    grid-column-gap: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    min-height: 40px;

    @media screen and (max-width: 575px) {
      display: block;
    }
  }

  .friends-section {
    .list {
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      grid-gap: 8px;

      .loader,
      .actions,
      .empty {
        grid-column: 1/10;
      }

      @media screen and (max-width: 678px) {
        grid-template-columns: repeat(5, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/6;
        }
      }

      @media screen and (max-width: 480px) {
        grid-template-columns: repeat(4, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/5;
        }
      }

      @media screen and (max-width: 360px) {
        grid-template-columns: repeat(3, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/4;
        }
      }
    }
  }

  .wishlist-section {
    .list {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 8px;
      text-align: center;

      .loader,
      .actions,
      .empty {
        grid-column: 1/7;
      }

      .position-relative {
        max-width: 156px;
      }

      @media screen and (max-width: 678px) {
        grid-template-columns: repeat(4, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/5;
        }
      }

      @media screen and (max-width: 480px) {
        grid-template-columns: repeat(3, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/4;
        }
      }

      @media screen and (max-width: 360px) {
        grid-template-columns: repeat(2, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/3;
        }
      }

      button {
        width: unset;
        margin: auto;
        min-width: 180px;
      }
    }
  }

  .purchased-list-section {
    .list {
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      grid-gap: 8px;
      text-align: center;

      .loader,
      .actions,
      .empty {
        grid-column: 1/10;
      }

      .position-relative {
        max-width: 100px;
      }

      @media screen and (max-width: 678px) {
        grid-template-columns: repeat(5, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/6;
        }
      }

      @media screen and (max-width: 480px) {
        grid-template-columns: repeat(4, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/5;
        }
      }

      @media screen and (max-width: 360px) {
        grid-template-columns: repeat(3, 1fr);

        .loader,
        .actions,
        .empty {
          grid-column: 1/4;
        }
      }
    }
  }

  .favorite-mark {
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    left: unset;
    position: absolute;
  }
  .my-events {
    padding-top: 32px;
    grid-column: 2/3;

    @media screen and (max-width: 575px) {
      grid-column: 1/3;
      padding-left: 8px;
    }

    .section-title {
      margin-bottom: 12px;
      cursor: pointer;
      width: fit-content;
    }

    .plus-icon {
      width: 24px;
      height: 24px;
      background-color: black;
      margin-right: 36px;
      border-radius: 50%;
      position: relative;

      &::before {
        content: "+";
        display: block;
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        color: white;
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        font-family: "Assistant", sans-serif;
      }
    }

    .event-date {
      width: 60px;
    }

    .events-list {
      @media screen and (min-width: 560px) {
        &.two-column {
          column-count: 2;
        }
      }
    }
  }
`;
